import { isValidNumber } from "./form.service";

export const checkFieldValidity = (addressList, getFieldState) =>
  addressList.every((field) => {
    const { error: errorField, invalid } = getFieldState(field.key);
    return !errorField && !invalid;
  });

export const getGeoCodeStatus = (sourceKey, data, setValue) => {
  const getCodeTagsToUpdate = ["latitude", "longitude"];
  let hasValidCode = true;
  getCodeTagsToUpdate.forEach((tag) => {
    const key = `${sourceKey}${tag.charAt(0).toUpperCase()}${tag.slice(1)}`;
    let code = data[tag];
    code = isValidNumber(code) ? `${code > 0 ? "+" : ""}${code}` : "";
    setValue(key, code);
    if (!code) hasValidCode = false;
  });
  return hasValidCode;
};
